import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import * as moment from 'moment';
import { DetalleFactura } from 'src/app/Models/factura/detallefactura/detalle-factura';
import { RangoFechas } from 'src/app/Models/rangofechas/rango-fechas';
import { AuthService } from 'src/app/Service/auth.service';
import { DataService } from 'src/app/Service/data.service';
import { NotifyService } from 'src/app/Service/notify.service';
import { ReportViewerService } from 'src/app/Service/report-viewer.service';

@Component({
  selector: 'app-print-ventasa-clientes',
  templateUrl: './print-ventasa-clientes.component.html',
  styleUrls: ['./print-ventasa-clientes.component.css'],
  providers: [DatePipe]
})
export class PrintVentasaClientesComponent implements OnInit {

  constructor(
    private reportViewer: ReportViewerService,
    private data: DataService,
    private datePipe: DatePipe,
    private cdr: ChangeDetectorRef
  ) { }
  mes: string = '1';
  public detfactus: any[] = [];
  public sumacantidad: number = 0;
  public sumapreuni: number = 0;
  public sumatotal: number = 0;
  public pagventas: any = 0;
  public rangofechas: RangoFechas = new RangoFechas();
  public today = new Date();
  public fecinicio: any;
  public fecfin: any;
  public sucursal: number;
  @ViewChild('pagina', null) public pagina: ElementRef;
  async ngOnInit() {
  }

  printer() {
    const doc = new jsPDF();
    console.log(this.pagina.nativeElement);
    doc.text("Hello world!", 10, 10);
    doc.save("a4.pdf");
  }
  formatFecha(fecha: Date | string, format: string): string {
    // Formatear la fecha a 'dd-MM-yyyy'
    return this.datePipe.transform(fecha, format) || '';
  }

  printerVentas():Blob | null {
    const doc = new jsPDF();
    const titulo = { text: 'VENTAS A CLIENTES', x: 80, y: 20 };


    // Función para agregar encabezado en cada página
    const addHeader = () => {
      doc.setFontSize(14);
      doc.text(titulo.text, titulo.x, titulo.y);
      const textWidth = doc.getTextWidth(titulo.text);  // Obtener el ancho del texto
      const lineY = titulo.y + 1;  // Posición Y de la línea (1 unidad por debajo del texto)

      doc.setLineWidth(0.5);  // Establecer el grosor de la línea
      doc.line(titulo.x, lineY, titulo.x + textWidth, lineY);
      doc.setFontSize(11);
      doc.text(`Del periodo ${this.formatFecha(this.fecinicio, 'dd-MM-yyyy')} al periodo ${this.formatFecha(this.fecfin, 'dd-MM-yyyy')}`, 10, 28);
      doc.text(`Generado el dia ${this.formatFecha(this.today, 'dd-MM-yyyy hh:mm')}`, 140, 28);
      //doc.addImage(this.empresa.logo, 'PNG', 10, 8, 20, 9);  // Añade tu imagen
      doc.setFontSize(12);
    };

    // Columnas de la tabla

    const tableColumn = ['N°', 'Fecha', 'Nombre Cliente', 'Celular', 'Producto', 'Cantidad', 'Vendedor'];
    const tableRows: any[] = [];

    // Obtener filas de una tabla HTML (ejemplo)
    const rows = document.querySelectorAll('#ventasaclientes tbody tr');
    rows.forEach(row => {
      const cols = row.querySelectorAll('td');
      const data: any[] = [];
      cols.forEach(col => data.push(col.innerText));
      tableRows.push(data);
    });

    // Usar autoTable para generar la tabla
    (doc as any).autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 35,
      margin: { horizontal: 10, vertical: 30 },
      theme: 'grid',
      columnStyles: {
        7: { halign: 'right' },
        8: { halign: 'right' },
        9: { halign: 'right' }
        // Alinear la columna "Cantidad" (índice 3) a la derecha
      },
      styles: {
        fontSize: 8,  // Controla el tamaño de fuente para todo el contenido de la tabla
        cellPadding: 1,  // Espaciado interno de las celdas
      },
      didDrawPage: (data: any) => {
        // Encabezado en cada página

        const pageNumber = data.pageNumber;  // Obtener el número de página
        //const pageCount = doc.getNumberOfPages();

        console.log(data.totalPages);

        addHeader();
        const pagetext = `Página ${pageNumber} `;
        doc.text(pagetext, 170, 15);  // Añade tu imagen
      },
      didDrawHeader: (data: any) => {
        doc.setFontSize(10);
        doc.text('N°', data.settings.margin.left, data.cursor.y);
        doc.text('Fecha', data.settings.margin.left, data.cursor.y);
        doc.text('Nombre Cliente', data.settings.margin.left, data.cursor.y);
        doc.text('Celular', data.settings.margin.left, data.cursor.y);
        doc.text('Producto', data.settings.margin.left, data.cursor.y);
        doc.text('Cantidad', data.settings.margin.left, data.cursor.y);
        doc.text('Vendedor', data.settings.margin.left, data.cursor.y);
      }
    });

    // Guardar el archivo PDF
    return doc.output('blob');
    //doc.save('informe.pdf');

  }


  onMonthSelect() {
    if (this.mes) {
      // Obtener el año actual
      const year = moment().year();

      // Obtener la fecha de inicio y fin del mes seleccionado usando Moment.js
      this.fecinicio = moment(`${year}-${this.mes}-01`).startOf('month').format('YYYY-MM-DD');
      this.fecfin = moment(`${year}-${this.mes}-01`).endOf('month').format('YYYY-MM-DD');
    }
  }

  GetData() {
    this.data.GetFromValue('ventasclientes', this.mes, this.sucursal.toString()).subscribe(r => {
      console.log(r);
      if (r.length < 1) {
        console.error("Error");
      } else {
        this.detfactus = r;
        this.GetTotalVentas()
        this.cdr.detectChanges();
        setTimeout(() => {
          // Generar el PDF
          const blob = this.printerVentas();
          // Mostrar en el modal reutilizable
          if (blob) {
            const fecha = this.formatFecha(new Date(), 'yyyy-MM-dd');
            this.reportViewer.mostrarPDF(
              blob,
              'Reporte de Ventas a Clientes',
              `reporte_ventas_clientes_${fecha}.pdf`
            );
          }
        }, 0);
      }
    }, (e) => { console.log(e) })
  }

  GetTotalVentas() {
    this.detfactus.forEach(detalle => {
      this.sumacantidad += +detalle.cantidad
      this.sumapreuni += +detalle.preuni
      this.sumatotal += +detalle.impnetoct
    });

  }

  // printerVentas(): Blob | null {
  //   const doc = new jsPDF();
  //   const titulo = { text: 'VENTAS A CLIENTES', x: 80, y: 20 };

  //   // Función para agregar encabezado en cada página
  //   const addHeader = () => {
  //     doc.setFontSize(14);
  //     doc.text(titulo.text, titulo.x, titulo.y);
  //     const textWidth = doc.getTextWidth(titulo.text);
  //     const lineY = titulo.y + 1;
  //     doc.setLineWidth(0.5);
  //     doc.line(titulo.x, lineY, titulo.x + textWidth, lineY);
  //     doc.setFontSize(11);
  //     doc.text(`Del periodo ${this.formatFecha(this.fecinicio, 'dd-MM-yyyy')} al periodo ${this.formatFecha(this.fecfin, 'dd-MM-yyyy')}`, 10, 28);
  //     doc.text(`Generado el dia ${this.formatFecha(this.today, 'dd-MM-yyyy hh:mm')}`, 140, 28);
  //     doc.setFontSize(12);
  //   };

  //   // Columnas de la tabla
  //   const tableColumn = ['N°', 'FECHA', 'NOMBRE CLIENTE', 'CELULAR', 'PRODUCTO', 'CANTIDAD', 'VENDEDOR'];
  //   const tableRows: any[] = [];

  //   // Construir filas desde detfactus
  //   this.detfactus.forEach((item: any, index: number) => {
  //     const row: any[] = [];
  //     row.push(index + 1);                    // N° orden
  //     row.push(item.fecha || '');             // Fecha
  //     row.push(item.nombre || '');            // Nombre Cliente
  //     row.push(item.celular || '');           // Celular
  //     row.push(item.producto || '');          // Producto
  //     row.push(item.cantidad || 0);           // Cantidad
  //     row.push(item.vendedor || '');          // Vendedor
  //     tableRows.push(row);
  //   });

  //   // Agregar fila de totales
  //   const rowTotal: any[] = [];
  //   rowTotal.push('TOTAL');
  //   rowTotal.push('');
  //   rowTotal.push('');
  //   rowTotal.push('');
  //   rowTotal.push('');
  //   rowTotal.push(this.sumacantidad);
  //   rowTotal.push('');
  //   tableRows.push(rowTotal);

  //   // Usar autoTable para generar la tabla
  //   (doc as any).autoTable({
  //     head: [tableColumn],
  //     body: tableRows,
  //     startY: 32,
  //     margin: { horizontal: 10 },
  //     theme: 'grid',
  //     headStyles: {
  //       halign: 'center',
  //       fillColor: [200, 200, 200],
  //       textColor: [0, 0, 0],
  //       fontStyle: 'bold',
  //       fontSize: 8
  //     },
  //     columnStyles: {
  //       0: { halign: 'center', cellWidth: 12 },  // N°
  //       1: { halign: 'center', cellWidth: 22 },  // Fecha
  //       2: { halign: 'left', cellWidth: 45 },    // Nombre Cliente
  //       3: { halign: 'center', cellWidth: 22 },  // Celular
  //       4: { halign: 'left', cellWidth: 40 },    // Producto
  //       5: { halign: 'center', cellWidth: 20 },  // Cantidad
  //       6: { halign: 'left', cellWidth: 30 }     // Vendedor
  //     },
  //     styles: {
  //       fontSize: 8,
  //       cellPadding: 1,
  //       overflow: 'linebreak'
  //     },
  //     didParseCell: (data: any) => {
  //       // Aplicar negrita a la última fila (totales)
  //       if (data.row.index === tableRows.length - 1 && data.section === 'body') {
  //         data.cell.styles.fontStyle = 'bold';
  //         data.cell.styles.fillColor = [240, 240, 240];
  //       }
  //     },
  //     didDrawPage: (data: any) => {
  //       addHeader();
  //       const pageNumber = data.pageNumber;
  //       doc.text(`Página ${pageNumber}`, 170, 15);
  //     }
  //   });

  //   // Retornar el blob en lugar de imprimir
  //   return doc.output('blob');
  // }


}
